import React from 'react';
import { Box } from '@material-ui/core';
import WaffleHeader from '../components/Header/WaffleHeader';
import { Pages } from '../routes/Pages';
import makeStyles from '@material-ui/styles/makeStyles';
import BlankHeader from '../components/Header/BlankHeader';
import { useSelector } from 'react-redux';
import { Store } from '../modules/root-reducer';

const useStyles = makeStyles({
	page: {
		maxWidth: '80vw',
		margin: '50px auto 100px',
		minHeight: '90vh',
	},
});

export const Mobile = () => {
	const classes = useStyles();
	const [showLogin, setShowLogin] = React.useState<boolean>(true);

	// ensure that you import Store from root-reducer.tsx, not from 'redux'!
	const token = useSelector<Store, string>(
		(store) => store.loginReducer.token
	);

	React.useEffect(() => {
		setShowLogin(token === '');
	}, [token]);

	return (
		<>
			<>
				{showLogin ? <BlankHeader /> : <WaffleHeader />}
				<Box className={classes.page}>
					<Pages />
				</Box>
			</>
		</>
	);
};
